import React from "react";
import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-stone-50 text-stone-700">
      <div className="font-serif text-6xl">404</div>
      <div className="mt-2 text-sm">Page not found.</div>
      <Link to="/" className="mt-4 text-emerald-800 underline text-sm" data-testid="notfound-home-link">Back to home</Link>
    </div>
  );
}
